import { put, takeLatest } from 'redux-saga/effects'
import { fireToastError } from '../../actions/toasts/fireToast'
import { changeUserObjectId } from '../../actions/userObject/changeUserIdObject'
import { IDataForObjectIsAccepted } from '../../actions/userObject/profile/requestFetchUserProfile'
import { IUserSettingsAccepted } from '../../actions/userObject/settings/requestFetchUserSettings'
import i18n from '../../i18n'
import {
  UserProfileActions,
  UserSettingsActions,
} from '../../reducers/userObject/actionNames'

function* changeIdWithSettings(action: IUserSettingsAccepted) {
  try {
    yield put(changeUserObjectId(action.settings.id))
  } catch (e) {
    yield fireToastError(i18n.t('errStatus_3'))
  }
}

function* changeIdWithProfile(action: IDataForObjectIsAccepted) {
  if (action.profile && action.profile.id) {
    yield put(changeUserObjectId(action.profile.id))
  }
}

export default function* () {
  yield takeLatest(
    UserSettingsActions.DataForUserSettingsAccepted,
    changeIdWithSettings,
  )
  yield takeLatest(
    UserProfileActions.DataForUserProfileAccepted,
    changeIdWithProfile,
  )
}
